import { render, staticRenderFns } from "./ShowComplaintAndObjectionAgainstViolation.vue?vue&type=template&id=cc50667c&"
import script from "./ShowComplaintAndObjectionAgainstViolation.vue?vue&type=script&lang=js&"
export * from "./ShowComplaintAndObjectionAgainstViolation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports